module.exports = __webpack_public_path__ + "img/bilibili.a22ab5c4.png";